/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type QueueCreateEmbeddedViewEntryPointComponent = EntryPointComponent<
	{},
	{},
	{},
	{
		projectKey: string;
	}
>;

export const gettingStartedQueueCreateEntryPoint: EntryPoint<
	QueueCreateEmbeddedViewEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<QueueCreateEmbeddedViewEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-getting-started-queue-create", jiraSpaEntry: "async-servicedesk-getting-started-queue-create" */ '@jira/servicedesk__solution-composer-embeds/src/QueueCreateEmbeddedView.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context: { match } }: EntryPointRouteParams) => {
		const projectKey = match.params.projectKey;

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		return {
			queries: {},
			extraProps: {
				projectKey,
			},
		};
	},
});
